import localforage from 'localforage'
import { create } from 'zustand'
import { StateStorage, createJSONStorage, persist } from 'zustand/middleware'
import CryptoJS from 'crypto-js'

const secretKey = 'my-strong-secret-key'

const LocalForageStorage: StateStorage = {
  getItem: async (name: string): Promise<string | null> => {
    const encryptedValue = await localforage.getItem(name)
    if (!encryptedValue) return null

    try {
      const bytes = CryptoJS.AES.decrypt(encryptedValue as string, secretKey)
      const decryptedValue = bytes.toString(CryptoJS.enc.Utf8)
      return JSON.parse(decryptedValue) // Parse and return the decrypted valu
    } catch (error) {
      console.error('Decryption error:', error)
      return null
    }
  },
  setItem: async (name: string, value: string): Promise<void> => {
    try {
      const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString()
      await localforage.setItem(name, encryptedValue)
    } catch (error) {
      console.error('Encryption error:', error)
    }
  },
  removeItem: async (name: string): Promise<void> => {
    await localforage.removeItem(name)
  }
}

interface IAppStore {
  isCreditoAnalisado: boolean
  setIsCreditoAnalisado: (value: boolean) => void
  resetCreditoAnalise: () => void
}

export const useCreditoAnaliseStore = create<IAppStore>()(
  persist(
    (set) => ({
      isCreditoAnalisado: false,
      setIsCreditoAnalisado: (value) => set(() => ({ isCreditoAnalisado: value })),
      resetCreditoAnalise: () => set(() => ({ isCreditoAnalisado: false }))
    }),
    {
      name: 'analise-storage',
      storage: createJSONStorage(() => LocalForageStorage)
    }
  )
)
